module.exports = __webpack_public_path__ + "static/media/sitawi.14ecb9e4.svg";